module.exports = __webpack_public_path__ + "static/media/profile-hannah.fb0d51fe.jpg";